import { configureStore } from '@reduxjs/toolkit'

import { apiSlice } from '@/apis/apiSlice'
import { v2Api } from '@/apis/v2Api'
import { portalApi } from '@/apis/portalApi'
import { authReducer } from '@/modules/auth/authSlice'
import { projectReducer } from '@/app/projectSlice'
import { notificationReducer } from '@/app/notificationSlice'
import { portalSessionReducer } from '@/modules/portal/portalSessionSlice'
import { sessionListener } from '@/app/session'

export function makeStore() {
    return configureStore({
        reducer: {
            [apiSlice.reducerPath]: apiSlice.reducer,
            [v2Api.reducerPath]: v2Api.reducer,
            [portalApi.reducerPath]: portalApi.reducer,
            auth: authReducer,
            project: projectReducer,
            notification: notificationReducer,
            portalSession: portalSessionReducer,
        },
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware()
                .prepend(sessionListener.middleware)
                .concat(apiSlice.middleware, v2Api.middleware, portalApi.middleware),
    })
}

export const store = makeStore()

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
